import { init as initAssetHandlers } from 'assetClass/application/assetClass/asset/handler';

export const init = () => {
  initAssetHandlers();
};
